import store from "../../../store";
import yandex_export from './yandex_export.vue';

window.yandex_export =  new Vue({
    store,
    el: 'div#yandex_export',

    name : "yandex_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        yandex_export,
    }
});
